import Wizard from "@/components/Wizard";

export default function WizardPage() {
  return (
    <main className="bg-ink min-h-screen pt-20" data-testid="wizard-page">
      <Wizard />
    </main>
  );
}
